export const categories = [
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line', description: '全网热门视频精选推荐' },
  { slug: 'news', name: '最新资讯', icon: 'ri-newspaper-line', description: '最新视频行业动态与资讯' },
  { slug: 'tutorial', name: '观看指南', icon: 'ri-guide-line', description: '视频观看技巧与使用教程' },
  { slug: 'review', name: '内容评测', icon: 'ri-star-line', description: '深度视频内容评测与分析' },
  { slug: 'tech', name: '技术分享', icon: 'ri-code-line', description: '视频技术与制作经验分享' },
  { slug: 'entertainment', name: '娱乐八卦', icon: 'ri-emotion-laugh-line', description: '娱乐视频圈热门话题' },
];

export const articles = [
  {
    id: 1,
    title: '2026年最值得关注的十大视频平台趋势',
    excerpt: '随着短视频、长视频和直播平台的持续演化，2026年的视频行业将迎来新一轮变革。本文将为你盘点今年最值得关注的十大趋势，帮助你把握内容创作的方向。',
    content: `<p>随着短视频、长视频和直播平台的持续演化，2026年的视频行业将迎来新一轮变革。本文将为你盘点今年最值得关注的十大趋势。</p>
<h3>一、AI 驱动的内容推荐更加精准</h3>
<p>人工智能算法在视频推荐领域的应用已经达到了前所未有的精度。平台能够根据用户的观看历史、停留时长、互动行为等多维度数据，为每位用户量身定制专属的内容流。这意味着用户将更容易发现自己真正感兴趣的视频内容。</p>
<h3>二、超高清画质成为标配</h3>
<p>4K、8K 甚至更高分辨率的视频内容正在快速普及。随着网络带宽的提升和显示设备的升级，观众对于画质的要求也越来越高。主流视频平台纷纷推出超高清专区，满足用户的视觉需求。</p>
<h3>三、互动式视频体验崛起</h3>
<p>传统被动观看的模式正在被打破。互动式视频允许观众在观看过程中做出选择，影响剧情走向。这种沉浸式的体验方式特别受到年轻用户群体的欢迎，也为内容创作者提供了全新的叙事可能性。</p>
<h3>四、跨平台内容联动加深</h3>
<p>视频内容不再局限于单一平台。创作者们开始打通多个渠道，通过长短视频结合、直播联动等方式，构建完整的内容生态。这种跨平台的策略帮助创作者触达更广泛的受众群体。</p>
<h3>五、社区化运营成为关键</h3>
<p>单纯的视频播放已经不能满足用户需求。围绕视频内容构建的社区生态——包括评论互动、粉丝群组、共创功能等——正在成为平台留住用户的核心竞争力。</p>`,
    category: 'news',
    author: '樱桃编辑部',
    date: '2026-07-20',
    readTime: '8分钟',
    views: 12830,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20content%20studio%20workspace%20with%20multiple%20screens%20displaying%20video%20analytics%20dashboards%20and%20trending%20content%20charts%20warm%20ambient%20lighting%20sleek%20minimalist%20design%20with%20cherry%20wood%20accents%20editorial%20photography%20high%20detail%20professional%20atmosphere&width=800&height=500&seq=article-1-news&orientation=landscape'
  },
  {
    id: 2,
    title: '新手必看：樱桃视频完整使用指南',
    excerpt: '刚接触樱桃视频？不用担心！这份详细的入门指南将带你从注册账号到发现优质内容，一步步掌握平台的所有核心功能，让你快速成为视频达人。',
    content: `<p>刚接触樱桃视频？不用担心！这份详细的入门指南将带你从注册账号到发现优质内容，一步步掌握平台的所有核心功能。</p>
<h3>第一步：注册并完善个人资料</h3>
<p>打开樱桃视频首页，点击右上角的注册按钮。你可以使用手机号或邮箱进行注册。注册成功后，建议花几分钟完善你的个人资料——上传头像、填写个人简介、选择你感兴趣的内容分类。这些信息将帮助系统为你推荐更精准的视频内容。</p>
<h3>第二步：探索内容分类</h3>
<p>樱桃视频拥有丰富的分类体系，包括热门推荐、最新资讯、观看指南、内容评测、技术分享和娱乐八卦等多个板块。你可以通过顶部导航栏或首页的分类区域快速切换不同的内容频道。</p>
<h3>第三步：使用搜索功能</h3>
<p>如果你有明确的内容需求，可以直接使用搜索功能。输入关键词后，系统将返回相关的视频、文章和频道推荐。高级搜索还支持按时间、热度、评分等维度进行筛选。</p>
<h3>第四步：互动与分享</h3>
<p>看到喜欢的视频内容，别忘了点赞、评论和分享。你的互动不仅能帮助优质内容获得更多曝光，也能让平台更好地理解你的内容偏好。</p>`,
    category: 'tutorial',
    author: '樱桃助手',
    date: '2026-07-18',
    readTime: '6分钟',
    views: 25640,
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20user%20interface%20tutorial%20screen%20showing%20video%20platform%20features%20with%20step%20by%20step%20guide%20overlay%20warm%20lighting%20soft%20shadows%20cherry%20themed%20design%20elements%20professional%20UI%20photography&width=800&height=500&seq=article-2-tutorial&orientation=landscape'
  },
  {
    id: 3,
    title: '深度评测：五大主流视频平台内容质量对比',
    excerpt: '我们花了整整一个月的时间，对目前市场上五大主流视频平台进行了全方位的内容质量评测。从画质、内容多样性、推荐算法到用户体验，这份评测报告将为你揭晓答案。',
    content: `<p>我们花了整整一个月的时间，对目前市场上五大主流视频平台进行了全方位的内容质量评测。这份报告将从多个维度为你揭晓各平台的真实表现。</p>
<h3>评测维度说明</h3>
<p>本次评测涵盖以下五个维度：画质表现（权重25%）、内容丰富度（权重25%）、推荐算法精准度（权重20%）、用户界面体验（权重15%）、社区活跃度（权重15%）。每个维度采用百分制打分。</p>
<h3>画质表现</h3>
<p>在画质方面，各大平台均支持4K播放。樱桃视频凭借自研的视频增强引擎，在同等码率下画面细节表现最优，色彩还原度也最为出色。特别是在暗光场景下，噪点控制明显优于竞品。</p>
<h3>内容丰富度</h3>
<p>综合五大平台的内容库规模，樱桃视频在垂直领域的深耕优势明显。虽然总量不及某些聚合型平台，但在精选内容和原创栏目的质量把控上更胜一筹。</p>
<h3>推荐算法精准度</h3>
<p>经过一个月的持续使用和数据采集，我们发现樱桃视频的推荐算法在"冷启动"阶段表现优异——新用户仅需浏览约10个视频后，推荐结果就能达到较高的相关度。</p>`,
    category: 'review',
    author: '樱桃评测组',
    date: '2026-07-15',
    readTime: '10分钟',
    views: 8930,
    image: 'https://readdy.ai/api/search-image?query=A%20side%20by%20side%20comparison%20display%20of%20five%20video%20streaming%20platforms%20on%20multiple%20screens%20with%20rating%20charts%20and%20quality%20metrics%20overlay%20professional%20review%20setup%20warm%20studio%20lighting%20clean%20modern%20workspace&width=800&height=500&seq=article-3-review&orientation=landscape'
  },
  {
    id: 4,
    title: '视频剪辑入门：从零开始学会制作高质量内容',
    excerpt: '想要创作自己的视频内容却不知从何下手？本文为零基础的新手准备了完整的视频剪辑入门教程，涵盖软件选择、基础操作、剪辑技巧和导出设置等关键环节。',
    content: `<p>想要创作自己的视频内容却不知从何下手？本文为零基础的新手准备了完整的视频剪辑入门教程。</p>
<h3>选择合适的剪辑软件</h3>
<p>对于新手来说，推荐从操作简单的软件开始。手机端可以选择剪映或 CapCut，功能全面且免费。电脑端可以尝试 DaVinci Resolve（免费版功能已非常强大）或 Final Cut Pro（Mac 用户首选）。</p>
<h3>基础剪辑操作流程</h3>
<p>一个完整的剪辑流程通常包括：素材导入与整理 → 粗剪（确定整体结构）→ 精剪（细化节奏和转场）→ 调色 → 添加字幕和特效 → 音频处理 → 导出渲染。</p>
<h3>提升视频质量的关键技巧</h3>
<p>首先是节奏控制——保持合适的剪辑节奏是吸引观众的关键。其次是转场设计——简洁流畅的转场远胜花哨的特效。最后是音频处理——好的配乐和清晰的人声能让视频质量提升一个档次。</p>`,
    category: 'tech',
    author: '樱桃创作社',
    date: '2026-07-12',
    readTime: '12分钟',
    views: 15670,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20editing%20workstation%20setup%20with%20dual%20monitors%20showing%20editing%20timeline%20and%20preview%20window%20creative%20studio%20environment%20with%20warm%20ambient%20lighting%20professional%20gear%20organized%20desk%20cherry%20wood%20elements&width=800&height=500&seq=article-4-tech&orientation=landscape'
  },
  {
    id: 5,
    title: '本周娱乐热搜：那些刷屏的视频名场面',
    excerpt: '过去一周，社交媒体上涌现了大量热门视频片段。从搞笑日常到感人瞬间，我们整理了本周最具话题度的十大视频名场面，看看你错过了哪些精彩内容。',
    content: `<p>过去一周，社交媒体上涌现了大量热门视频片段。从搞笑日常到感人瞬间，我们整理了本周最具话题度的十大视频名场面。</p>
<h3>TOP 1：街舞少年惊艳全网</h3>
<p>一段来自成都街头的即兴街舞视频在短短两天内获得了超过五千万次播放。视频中一位年仅12岁的少年在太古里广场跟随音乐起舞，高难度的地板动作和流畅的节奏感让路人纷纷驻足拍摄。</p>
<h3>TOP 2：萌宠界的"奥斯卡"时刻</h3>
<p>一只金毛犬为主人叼来拖鞋的温馨视频感动了无数网友。视频中狗狗小心翼翼地用嘴衔着拖鞋，摇着尾巴走向正在沙发上休息的主人，画面温暖治愈。</p>
<h3>TOP 3：工地大叔的惊艳嗓音</h3>
<p>一段建筑工地上工人休息时演唱《青藏高原》的视频意外走红。这位大叔未经专业训练的嗓音却极具穿透力，让无数网友感叹"高手在民间"。</p>`,
    category: 'entertainment',
    author: '樱桃八卦社',
    date: '2026-07-10',
    readTime: '5分钟',
    views: 31200,
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20social%20media%20trending%20video%20compilation%20display%20with%20multiple%20floating%20video%20thumbnails%20showing%20viral%20moments%20colorful%20modern%20layout%20entertainment%20news%20style%20warm%20energetic%20atmosphere%20cherry%20red%20accents&width=800&height=500&seq=article-5-entertainment&orientation=landscape'
  },
  {
    id: 6,
    title: '2026夏季热门视频内容消费报告',
    excerpt: '基于后台大数据分析，我们发布了2026年夏季视频内容消费趋势报告。数据显示，今年夏天的观看时长同比增长了35%，其中知识科普类内容增速最为显著。',
    content: `<p>基于后台大数据分析，我们发布了2026年夏季视频内容消费趋势报告。本报告覆盖了今年6月至7月期间的用户行为数据。</p>
<h3>总体消费趋势</h3>
<p>2026年夏季，视频内容的总观看时长同比增长了35%。人均每日观看时长达到2.8小时，周末更是攀升至3.5小时。这一增长主要得益于高质量原创内容的持续供给和个性化推荐的不断优化。</p>
<h3>内容品类增长排行</h3>
<p>知识科普类内容以62%的增速领跑所有品类，成为今年夏天最大的黑马。紧随其后的是美食制作（+48%）、旅游vlog（+42%）和科技评测（+38%）。</p>
<h3>用户画像洞察</h3>
<p>18至35岁的年轻用户仍然是视频消费的主力军，占比达到68%。值得注意的是，45岁以上的银发用户群体增速达到了惊人的85%，显示视频内容正在向全年龄段渗透。</p>`,
    category: 'news',
    author: '樱桃数据组',
    date: '2026-07-08',
    readTime: '7分钟',
    views: 9870,
    image: 'https://readdy.ai/api/search-image?query=A%20data%20analytics%20dashboard%20with%20colorful%20charts%20and%20graphs%20showing%20video%20content%20consumption%20trends%20summer%202026%20statistics%20modern%20business%20intelligence%20interface%20warm%20professional%20atmosphere&width=800&height=500&seq=article-6-news&orientation=landscape'
  },
  {
    id: 7,
    title: '如何利用碎片时间高效观看学习类视频',
    excerpt: '通勤、午休、排队……生活中充满了碎片时间。本文将分享一套科学的方法论，教你如何在零散的时间段里高效吸收学习类视频的核心知识点，让每一分钟都物超所值。',
    content: `<p>通勤、午休、排队……生活中充满了碎片时间。本文将分享一套科学的方法论，教你如何在零散的时间段里高效吸收学习类视频的核心知识点。</p>
<h3>碎片学习的黄金法则</h3>
<p>碎片时间学习的核心不在于"看多少"，而在于"记住多少"。我们推荐"3-5-10法则"：每次观看3-5分钟的视频片段，用10秒回顾核心要点，再决定是否需要继续深入学习。</p>
<h3>推荐的学习类视频类型</h3>
<p>短小精悍的科普动画、知识点拆解类的教程视频、带字幕的外语学习内容——这些类型特别适合碎片化学习。建议优先选择时长在5-10分钟以内的内容。</p>
<h3>配套工具推荐</h3>
<p>搭配笔记工具使用能大幅提升学习效率。推荐使用 Notion 或飞书文档建立个人知识库，将每次碎片学习的要点记录整理，周末再进行系统回顾和串联。</p>`,
    category: 'tutorial',
    author: '樱桃学习社',
    date: '2026-07-05',
    readTime: '6分钟',
    views: 7230,
    image: 'https://readdy.ai/api/search-image?query=A%20person%20watching%20educational%20videos%20on%20a%20tablet%20during%20daily%20commute%20on%20public%20transport%20with%20note%20taking%20app%20open%20on%20phone%20split%20screen%20warm%20natural%20lighting%20modern%20lifestyle%20photography&width=800&height=500&seq=article-7-tutorial&orientation=landscape'
  },
  {
    id: 8,
    title: '直播行业的下一站：虚拟人直播技术全解析',
    excerpt: '虚拟人直播正在以惊人的速度改变直播行业的格局。从技术原理到商业应用，本文全面解析虚拟人直播的现状与未来，带你了解这个炙手可热的新赛道。',
    content: `<p>虚拟人直播正在以惊人的速度改变直播行业的格局。从技术原理到商业应用，本文全面解析虚拟人直播的现状与未来。</p>
<h3>虚拟人直播的技术基础</h3>
<p>虚拟人直播的核心技术包括：3D建模与渲染、动作捕捉、实时面部表情驱动、自然语言处理和语音合成。这些技术的融合使得虚拟主播能够以高度逼真的形象与观众实时互动。</p>
<h3>商业应用场景</h3>
<p>目前，虚拟人直播已在电商带货、品牌营销、在线教育和娱乐直播等领域广泛应用。相比真人主播，虚拟人具有24小时不间断、形象统一可控、成本逐渐降低等优势。</p>
<h3>未来发展趋势</h3>
<p>随着AI技术的持续进步，虚拟人的交互能力和表现力将不断提升。预计到2027年，虚拟人直播的市场规模将突破千亿级别，成为数字经济的重要组成部分。</p>`,
    category: 'tech',
    author: '樱桃科技组',
    date: '2026-07-02',
    readTime: '9分钟',
    views: 11450,
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20virtual%20human%20streaming%20studio%20setup%20with%20holographic%20display%20motion%20capture%20equipment%20and%20AI%20interface%20screens%20cyberpunk%20aesthetic%20with%20warm%20neon%20accents%20sleek%20modern%20technology%20showcase&width=800&height=500&seq=article-8-tech&orientation=landscape'
  },
  {
    id: 9,
    title: '经典回顾：那些年改变行业的十部纪录片',
    excerpt: '优秀的纪录片不仅能带来知识，更能改变人们对世界的认知。我们精选了十部在视频行业具有里程碑意义的纪录片，每一部都值得反复观看和深入思考。',
    content: `<p>优秀的纪录片不仅能带来知识，更能改变人们对世界的认知。我们精选了十部在视频行业具有里程碑意义的纪录片。</p>
<h3>1. 《互联网之子》</h3>
<p>这部纪录片讲述了互联网活动家亚伦·斯沃茨的传奇人生。他的故事深刻影响了开放互联网运动，也让人们重新思考信息自由与社会正义的关系。对于每一位互联网从业者和内容创作者来说，这都是一部必看的作品。</p>
<h3>2. 《社交困境》</h3>
<p>这部Netflix原创纪录片揭示了社交媒体平台背后的算法机制及其对社会的影响。它引发了全球范围内关于科技伦理和数字健康的广泛讨论，是理解当代视频传播生态的绝佳入口。</p>
<h3>3. 《地球脉动》系列</h3>
<p>BBC的《地球脉动》系列重新定义了自然纪录片的制作标准。其开创性的拍摄技术和震撼的视觉呈现，不仅为观众带来了前所未有的视听体验，也为整个视频行业树立了品质标杆。</p>`,
    category: 'review',
    author: '樱桃文化组',
    date: '2026-06-28',
    readTime: '11分钟',
    views: 6780,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20collection%20of%20classic%20documentary%20film%20posters%20arranged%20in%20an%20elegant%20gallery%20wall%20setting%20warm%20ambient%20lighting%20vintage%20cinema%20aesthetic%20with%20modern%20touches%20cherry%20wood%20frames&width=800&height=500&seq=article-9-review&orientation=landscape'
  },
  {
    id: 10,
    title: '视频平台的社区文化是如何形成的',
    excerpt: '一个视频平台的成功不仅取决于内容质量，更与其社区文化密不可分。本文深入探讨视频平台社区文化的形成机制，分析弹幕文化、粉丝经济和共创生态的相互作用。',
    content: `<p>一个视频平台的成功不仅取决于内容质量，更与其社区文化密不可分。本文深入探讨视频平台社区文化的形成机制。</p>
<h3>弹幕文化的独特魅力</h3>
<p>弹幕作为一种即时互动形式，已经成为中文视频社区最具特色的文化符号。它不仅是一种评论方式，更是一种集体观看体验——观众不再是孤立的个体，而是共同参与内容消费的"在场者"。</p>
<h3>粉丝经济与创作者生态</h3>
<p>粉丝与创作者之间形成的独特经济关系，是视频社区活力的核心来源。打赏、会员订阅、周边商品等多种变现方式，为创作者提供了持续创作的动力，也让粉丝获得了参与感和归属感。</p>
<h3>共创内容的崛起</h3>
<p>越来越多的视频平台开始鼓励用户参与内容共创。从评论区的段子手到二次创作的剪刀手，用户不再只是内容的消费者，而是内容生态的共建者。</p>`,
    category: 'entertainment',
    author: '樱桃观察室',
    date: '2026-06-25',
    readTime: '8分钟',
    views: 5430,
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20online%20video%20community%20interface%20with%20floating%20comments%20danmaku%20bullet%20chat%20streaming%20across%20the%20screen%20engaged%20audience%20interaction%20warm%20colorful%20digital%20atmosphere%20modern%20social%20media%20concept&width=800&height=500&seq=article-10-entertainment&orientation=landscape'
  },
  {
    id: 11,
    title: '2026下半年最受期待的视频内容前瞻',
    excerpt: '随着各大平台陆续公布下半年的内容计划，我们整理了其中最值得期待的10部即将上线的视频内容，涵盖剧集、综艺、纪录片等多个品类，提前锁定你的观看清单。',
    content: `<p>随着各大平台陆续公布下半年的内容计划，我们整理了其中最值得期待的即将上线的视频内容。</p>
<h3>重磅剧集</h3>
<p>多部大制作的国产剧集将在下半年陆续上线。其中，改编自热门小说的古装悬疑剧《长安谜案》备受瞩目，其制作团队在视觉呈现上投入了前所未有的预算，有望成为年度爆款。</p>
<h3>创新综艺</h3>
<p>综艺领域同样精彩纷呈。全新形式的沉浸式真人秀《极限72小时》将邀请明星嘉宾在极限环境下完成挑战，融合了纪录片和真人秀的双重叙事手法。</p>
<h3>纪录片佳作</h3>
<p>由国际团队耗时三年打造的《丝绸之路新篇章》即将首播。这部六集纪录片采用最先进的8K拍摄技术，以全新的视角展现丝绸之路沿线国家的当代风貌。</p>`,
    category: 'hot',
    author: '樱桃编辑部',
    date: '2026-06-22',
    readTime: '7分钟',
    views: 18920,
    image: 'https://readdy.ai/api/search-image?query=An%20exciting%20preview%20showcase%20of%20upcoming%20video%20content%20with%20movie%20posters%20series%20trailers%20and%20entertainment%20announcements%20displayed%20on%20a%20futuristic%20media%20wall%20warm%20cinematic%20lighting%20anticipation%20atmosphere&width=800&height=500&seq=article-11-hot&orientation=landscape'
  },
  {
    id: 12,
    title: '视频SEO优化：让你的内容被更多人看到',
    excerpt: '创作了好的视频内容，如何让它被更多人发现？视频SEO优化是关键。本文从标题优化、标签策略、缩略图设计到发布时机选择，全面讲解视频SEO的实战技巧。',
    content: `<p>创作了好的视频内容，如何让它被更多人发现？视频SEO优化是关键。本文全面讲解视频SEO的实战技巧。</p>
<h3>标题优化的三大原则</h3>
<p>一个好的视频标题需要兼顾三个要素：包含核心关键词、激发好奇心、明确价值承诺。建议标题长度控制在20-40个字符之间，前置核心关键词以获得更好的搜索排名。</p>
<h3>标签策略与关键词布局</h3>
<p>标签不是越多越好。推荐使用"3+5+2"策略：3个核心标签（与内容直接相关）、5个长尾标签（拓展搜索场景）、2个趋势标签（借势热点话题）。</p>
<h3>缩略图的视觉心理学</h3>
<p>缩略图是用户决定是否点击的第一道关卡。高点击率的缩略图通常具备以下特征：高对比度的色彩搭配、清晰的人物面部表情（如有）、简洁有力的文字标注。建议使用暖色调，因为数据表明暖色缩略图的点击率平均高出冷色23%。</p>`,
    category: 'tech',
    author: '樱桃增长组',
    date: '2026-06-20',
    readTime: '7分钟',
    views: 8450,
    image: 'https://readdy.ai/api/search-image?query=A%20video%20SEO%20optimization%20workspace%20with%20analytics%20dashboards%20keyword%20research%20tools%20and%20thumbnail%20design%20interface%20on%20multiple%20screens%20professional%20digital%20marketing%20setup%20warm%20lighting%20modern%20creative%20studio&width=800&height=500&seq=article-12-tech&orientation=landscape'
  },
];

export const faqs = [
  {
    question: '樱桃视频是什么？',
    answer: '樱桃视频是一个专注于精选视频内容与资讯的综合平台。我们为视频爱好者提供热门内容推荐、最新行业资讯、观看指南以及实用技巧分享，帮助用户发现更多值得关注的优质视频内容。',
  },
  {
    question: '樱桃视频是免费的吗？',
    answer: '是的，樱桃视频的所有内容和资讯均为免费提供。我们致力于为用户打造一个开放、优质的视频内容资讯平台，无需付费即可浏览全部内容。部分深度专题内容可能需要注册账号后查看。',
  },
  {
    question: '如何找到我感兴趣的视频内容？',
    answer: '你可以通过以下几种方式发现感兴趣的内容：使用首页顶部的搜索框输入关键词进行搜索；浏览首页的分类导航区域，选择你感兴趣的内容频道；查看"热门推荐"板块了解当前最受欢迎的内容；关注"最新资讯"获取实时更新的视频行业动态。',
  },
  {
    question: '樱桃视频的内容多久更新一次？',
    answer: '我们的编辑团队每天更新内容，确保用户能够获取到最新、最热的视频资讯。热门推荐栏目每日更新，深度评测和专题文章每周发布3-5篇，行业报告和分析类内容则按月或按季度发布。',
  },
  {
    question: '我可以在樱桃视频上发布自己的视频内容吗？',
    answer: '目前樱桃视频主要提供视频资讯和内容推荐服务，暂不支持用户直接上传视频。不过，我们欢迎视频创作者通过"关于我们"页面的联系方式与我们取得联系，探讨内容合作的可能性。',
  },
  {
    question: '樱桃视频支持哪些设备观看？',
    answer: '樱桃视频网站采用了响应式设计，完美适配桌面电脑、平板和手机等多种设备。无论你使用 Windows、macOS、iOS 还是 Android 系统，都能获得流畅的浏览体验。建议使用 Chrome、Safari 或 Edge 等主流浏览器访问。',
  },
  {
    question: '如何联系樱桃视频的客服团队？',
    answer: '你可以通过"关于我们"页面上的联系表单提交问题或建议，我们的客服团队会在24小时内回复。此外，也可以通过页面底部显示的联系邮箱直接发送邮件，或者关注我们的社交媒体账号获取最新动态。',
  },
  {
    question: '樱桃视频的内容来源是否可靠？',
    answer: '樱桃视频的内容由专业的编辑团队进行策划和撰写，所有资讯类内容均经过严格的事实核查。我们的评测和分析文章基于真实数据和实际体验，努力为用户提供客观、专业、有价值的信息。如发现内容存在不准确之处，欢迎随时反馈，我们将及时核实和更正。',
  },
];

export const aboutData = {
  brandName: '樱桃视频',
  brandIntro: '樱桃视频成立于2024年，是一家专注于视频内容精选与资讯服务的综合性平台。我们以"让好内容被更多人看见"为使命，致力于为视频爱好者提供高质量的内容推荐、深度的行业分析和实用的观看指南。经过两年多的发展，樱桃视频已经积累了超过百万的忠实用户，成为中文视频资讯领域值得信赖的品牌。',
  mission: '我们的使命是连接优质内容与目标受众，帮助每一位视频爱好者发现更多值得关注的好内容。',
  vision: '成为中文互联网最具影响力的视频内容资讯平台，推动视频行业的内容品质提升与生态健康发展。',
  stats: [
    { label: '精选文章', value: '2,500+' },
    { label: '覆盖分类', value: '30+' },
    { label: '月活用户', value: '120万+' },
    { label: '合作创作者', value: '800+' },
  ],
  milestones: [
    { year: '2024年3月', event: '樱桃视频正式上线，推出首批5个内容分类频道' },
    { year: '2024年8月', event: '月活用户突破50万，被多家科技媒体评为"年度最具潜力内容平台"' },
    { year: '2025年1月', event: '推出深度评测栏目，建立专业的内容评价体系' },
    { year: '2025年6月', event: '完成品牌升级，内容分类扩展至30+，合作创作者超过500位' },
    { year: '2025年12月', event: '月活用户突破100万，入选"年度十大内容资讯平台"' },
    { year: '2026年3月', event: '推出AI个性化推荐系统，用户内容匹配度提升40%' },
    { year: '2026年7月', event: '持续优化产品体验，致力于为用户提供更优质的视频资讯服务' },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '资深视频创作者',
      content: '樱桃视频的内容推荐质量非常高，每次打开都能发现让我眼前一亮的优质视频。作为创作者，我也经常参考他们的行业分析文章来调整自己的内容策略。',
      avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20man%20portrait%20photo%20in%20business%20casual%20attire%20warm%20friendly%20expression%20clean%20white%20background%20studio%20lighting%20headshot%20style&width=100&height=100&seq=testimonial-1&orientation=squarish',
    },
    {
      name: '李女士',
      role: '内容运营经理',
      content: '我在一家视频平台做内容运营，樱桃视频的行业报告和趋势分析是我们团队必读的参考资料。数据详实、观点独到，对工作非常有帮助。',
      avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20woman%20portrait%20photo%20in%20modern%20office%20attire%20confident%20warm%20smile%20clean%20white%20background%20studio%20lighting%20headshot%20style&width=100&height=100&seq=testimonial-2&orientation=squarish',
    },
    {
      name: '王同学',
      role: '大学在读学生',
      content: '作为一个重度视频用户，樱桃视频帮我节省了大量筛选内容的时间。他们的观看指南和分类整理做得特别好，推荐给所有喜欢看视频的朋友！',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20student%20portrait%20photo%20casual%20style%20friendly%20smile%20clean%20white%20background%20studio%20lighting%20headshot%20style&width=100&height=100&seq=testimonial-3&orientation=squarish',
    },
  ],
  contact: {
    email: 'contact@cherryvideo.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园B座15层',
    wechat: 'cherryvideo_official',
    weibo: '@樱桃视频官方',
  },
};